import { createContext } from 'react';
import PropTypes from 'prop-types';
import styles from './radio.css';


const RadioContext = createContext();
const RadioProvider = RadioContext.Provider;
const RadioConsumer = RadioContext.Consumer;


const RadioGroup = ({
  name, value, handleChange, children,
}) => (
  <RadioProvider
    value={{
      name,
      value,
      handleChange,
    }}
  >
    <div className={styles.buttonGroupContainer}>
      {children.map((child, i) => (
        <div className={styles.buttonContainer} key={`${i};${child.value}`}>
          {child}
          {(children.length > i + 1) && <div className={styles.buttonSeparator} />}
        </div>
      ))}
    </div>
  </RadioProvider>
);

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  children: PropTypes.node,
};


const RadioButton = ({ value, text }) => (
  <RadioConsumer>
    {(radioGroup) => (
      <label
        htmlFor={value}
        className={`${styles.button} ${radioGroup.value === value ? styles.active : ''}`}
      >
        {text}
        <input
          id={value}
          type="radio"
          name={radioGroup.name}
          checked={radioGroup.value === value}
          value={value}
          onChange={radioGroup.handleChange}
        />
      </label>
    )}
  </RadioConsumer>
);

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};


export { RadioGroup, RadioButton };
